/* eslint-disable prettier/prettier */
/* eslint-disable import/no-duplicates */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import { FaTrashAlt, FaWhatsapp } from 'react-icons/fa';

import api from '../../../services/api';

import { montaLinkWhatsappWeb, TIPO_USUARIO } from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';
import { useAuth } from '../../../hooks/auth';

import Input from '../../../components/Input';
import SelectSync from '../../../components/SelectSync';
import SelectAsync from '../../../components/SelectAsync';
import Loading from '../../../components/Loading';
import Paginacao from '../../../components/Paginacao';

import getValidationErrors from '../../../utils/getValidationErrors';

import { RelatorioHeader } from './styles';
import getResponseErrors from '../../../utils/getResponseErrors';
import { optionsSexo, optionsSimNao } from '../../../utils/options';
import InputCheck from '../../../components/InputCheck';

interface IRequestBuscaPacienteAvancadoDTO {
  dataCadastroInicio?: Date;
  dataCadastroFim?: Date;
  dataNascimentoInicio?: Date;
  dataNascimentoFim?: Date;
  sexo?: string;
  atendidoPeloPerfil?: { codigos: number[]; dataInicio?: Date; dataFim?: Date };
  realizouProcedimento?: {
    codigos: number[];
    dataInicio?: Date;
    dataFim?: Date;
  };
  naoRealizouProcedimento?: {
    codigos: number[];
    dataInicio?: Date;
    dataFim?: Date;
  };
  ehAssociadoAtivo?: boolean;
  ehAssociadoAtrasado?: boolean;
  naoAssociado?: boolean;
  pessoaFisica?: boolean;
  limite: number;
  pagina: number;
}

interface IRelatorio {
  PacCodigo: number;
  PacNome: string;
  PacDataNasc: Date;
  PacDataNascFormatado: string;
  Idade: string;
  PacSexo: string;
  PacCelular: string;
  PacTelefone: string;
  PacDataCadastro: Date;
  PacDataCadastroFormatado: string;
  PacEmail: string;
  PacResponsavel: string;
  PacPessoaFisica: boolean;
  linkWhatsappWeb: string;
}

interface IRetornoRelatorio {
  data: IRelatorio[];
  count: number;
}

interface IFormBusca {
  dataCadastroInicio?: Date;
  dataCadastroFim?: Date;
  dataNascimentoInicio?: Date;
  dataNascimentoFim?: Date;
  sexo?: string;
  ehAssociado?: string;
  pessoaFisica?: boolean;
  dataRealizouInicio?: Date;
  dataRealizouFim?: Date;
  dataNaoRealizouInicio?: Date;
  dataNaoRealizouFim?: Date;
  dataAtendimentoPerfilInicio?: Date;
  dataAtendimentoPerfilFim?: Date;
}

interface IPaginacao extends IFormBusca {
  limite: number;
  pagina: number;
}

interface IConverteData {
  data: Date;
  busca: string;
  exibi: string;
}

const optionsAssociado = [
  {
    label: 'Sim - Ativo',
    value: '1',
  },
  {
    label: 'Sim - Atrasado',
    value: '2',
  },
  {
    label: 'Não',
    value: '0',
  },
];

function converteDataStringParaBusca(data?: Date): IConverteData | undefined {
  if (!data) return undefined;
  const dataDate = parseISO(data.toString());
  return {
    data: dataDate,
    busca: `${format(dataDate, 'yyyy-MM-dd')} 03:00:00`,
    exibi: format(dataDate, 'dd/MM/yyyy'),
  };
}

function formataDataExibirRealtorio(data?: Date): string {
  if (!data) return ' ';
  return format(parseISO(data.toString()), 'dd/MM/yyyy');
}

interface IProcedimentosSelecionados {
  ProCodigo: number;
  ProNome: string;
}

interface IFormataCamposEspeciais {
  codigos: number[];
  dataInicio?: Date;
  dataFim?: Date;
}

function formataCamposEspeciais({
  codigos,
  dataInicio,
  dataFim,
}: IFormataCamposEspeciais): IFormataCamposEspeciais {
  const dataInicioOk = converteDataStringParaBusca(dataInicio);
  const dataFimOk = converteDataStringParaBusca(dataFim);

  return {
    codigos,
    ...(dataInicioOk && {
      dataInicio: dataInicioOk.data,
    }),
    ...(dataFimOk && { dataFim: dataFimOk.data }),
  };
}

type WhenCondition = {
  is: (value: any) => boolean;
  then: (schema: Yup.AnySchema) => Yup.AnySchema;
  otherwise?: (schema: Yup.AnySchema) => Yup.AnySchema;
};

const PacienteBuscaAvancada: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();
  const { imagensClinica, optionsClinica } = useClinica();
  const clinica =
    optionsClinica && optionsClinica.length > 0 ? optionsClinica[0].label : '';

  const logo =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState<IRelatorio[]>();
  const [paginacao, setPaginacao] = useState<IPaginacao>();
  const [totalRegistros, setTotalRegistros] = useState<number>();
  const initialData = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    CliCodigo: user.UsuClinica.toString(),
  };
  const [parametrosExibe, setParametrosExibe] = useState('');

  const [realizouProcedimentos, setRealizouProcedimentos] = useState(false);
  const [procedimentosRealizados, setProcedimentosRealizados] = useState<
    IProcedimentosSelecionados[]
  >([]);
  const [naoRealizouProcedimentos, setNaoRealizouProcedimentos] = useState(
    false,
  );
  const [procedimentosNaoRealizados, setProcedimentosNaoRealizados] = useState<
    IProcedimentosSelecionados[]
  >([]);

  const [atendidoPelosPerfil, setAtendidoPelosPerfil] = useState(false);
  const [perfilAtendimentos, setPerfilAtendimentos] = useState<
    IProcedimentosSelecionados[]
  >([]);

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const handleBuscar = useCallback(
    async (dadosBusca: IPaginacao) => {
      try {
        if (!dadosBusca) return;
        setLoading(true);
        const {
          dataCadastroInicio,
          dataCadastroFim,
          dataNascimentoInicio,
          dataNascimentoFim,
          ehAssociado,
          pessoaFisica,
          sexo,
          dataRealizouInicio,
          dataRealizouFim,
          dataNaoRealizouInicio,
          dataNaoRealizouFim,
          dataAtendimentoPerfilInicio,
          dataAtendimentoPerfilFim,
          limite,
          pagina,
        } = dadosBusca;

        let filtrosTexto = '';

        const dataCadastroInicioOk = converteDataStringParaBusca(
          dataCadastroInicio,
        );
        const dataCadastroFimOk = converteDataStringParaBusca(dataCadastroFim);

        if (dataCadastroInicioOk && dataCadastroFimOk)
          filtrosTexto += ` - Data de Cadastro: ${dataCadastroInicioOk.exibi} à ${dataCadastroFimOk.exibi}`;

        const dataNascimentoInicioOk = converteDataStringParaBusca(
          dataNascimentoInicio,
        );
        const dataNascimentoFimOk = converteDataStringParaBusca(
          dataNascimentoFim,
        );

        if (dataNascimentoInicioOk && dataNascimentoFimOk)
          filtrosTexto += ` - Data de Nascimento: ${dataNascimentoInicioOk.exibi} à ${dataNascimentoFimOk.exibi}`;

        if (sexo) filtrosTexto += ` - Sexo: ${sexo}`;
        if (ehAssociado) {
          if (ehAssociado === '1') filtrosTexto += ` - Associado: Sim - Ativo`;
          if (ehAssociado === '2')
            filtrosTexto += ` - Associado: Sim - Atrasado`;
          if (ehAssociado === '0')
            filtrosTexto += ` - Associado: Não`;
        }
        if (pessoaFisica)
          filtrosTexto += ` - Pessoa Fisica: ${pessoaFisica.toString().toLocaleLowerCase() === 'true'
            ? 'Sim'
            : 'Não'
            }`;

        // REALIZOU PROCEDIMENTOS
        const realizouProcedimento =
          realizouProcedimentos && procedimentosRealizados.length > 0
            ? formataCamposEspeciais({
              codigos: procedimentosRealizados.map(prod =>
                Number(prod.ProCodigo),
              ),
              dataInicio: dataRealizouInicio,
              dataFim: dataRealizouFim,
            })
            : undefined;

        if (realizouProcedimento) {
          filtrosTexto += ` - Realizou Procedimentos: ${procedimentosRealizados
            .map(prod => prod.ProNome)
            .join(', ')}`;
          filtrosTexto +=
            realizouProcedimento.dataInicio && realizouProcedimento.dataFim
              ? ` entre ${format(
                realizouProcedimento.dataInicio,
                'dd/MM/yyyy',
              )} e ${format(realizouProcedimento.dataFim, 'dd/MM/yyyy')}`
              : '';
        }

        // NÃO REALIZOU PROCEDINENTOS
        const naoRealizouProcedimento =
          naoRealizouProcedimentos && procedimentosNaoRealizados.length > 0
            ? formataCamposEspeciais({
              codigos: procedimentosNaoRealizados.map(prod =>
                Number(prod.ProCodigo),
              ),
              dataInicio: dataNaoRealizouInicio,
              dataFim: dataNaoRealizouFim,
            })
            : undefined;

        if (naoRealizouProcedimento) {
          filtrosTexto += ` - Não Realizou Procedimentos: ${procedimentosNaoRealizados
            .map(prod => prod.ProNome)
            .join(', ')}`;
          filtrosTexto +=
            naoRealizouProcedimento.dataInicio &&
              naoRealizouProcedimento.dataFim
              ? ` entre ${format(
                naoRealizouProcedimento.dataInicio,
                'dd/MM/yyyy',
              )} e ${format(naoRealizouProcedimento.dataFim, 'dd/MM/yyyy')}`
              : '';
        }

        // ATENDIDO PELOS PERFIS
        const atendidoPeloPerfil =
          atendidoPelosPerfil && perfilAtendimentos.length > 0
            ? formataCamposEspeciais({
              codigos: perfilAtendimentos.map(prod => Number(prod.ProCodigo)),
              dataInicio: dataAtendimentoPerfilInicio,
              dataFim: dataAtendimentoPerfilFim,
            })
            : undefined;

        if (atendidoPeloPerfil) {
          filtrosTexto += ` - Atendido pelos Perfis: ${perfilAtendimentos
            .map(prod => prod.ProNome)
            .join(', ')}`;
          filtrosTexto +=
            atendidoPeloPerfil.dataInicio && atendidoPeloPerfil.dataFim
              ? ` entre ${format(
                atendidoPeloPerfil.dataInicio,
                'dd/MM/yyyy',
              )} e ${format(atendidoPeloPerfil.dataFim, 'dd/MM/yyyy')}`
              : '';
        }

        const buscaBody: IRequestBuscaPacienteAvancadoDTO = {
          dataCadastroInicio: dataCadastroInicioOk?.data,
          dataCadastroFim: dataCadastroFimOk?.data,
          dataNascimentoInicio: dataNascimentoInicioOk?.data,
          dataNascimentoFim: dataNascimentoFimOk?.data,
          ...(ehAssociado && ehAssociado === '0' && { naoAssociado: true }),
          ...(ehAssociado && ehAssociado === '1' && { ehAssociadoAtivo: true }),
          ...(ehAssociado &&
            ehAssociado === '2' && { ehAssociadoAtrasado: true }),
          ...(pessoaFisica && { pessoaFisica }),
          ...(sexo && { sexo }),
          realizouProcedimento,
          naoRealizouProcedimento,
          atendidoPeloPerfil,
          limite,
          pagina,
        };

        filtrosTexto = `${format(
          new Date(),
          'dd/MM/yyyy HH:mm:ss',
        )} ${filtrosTexto}`;

        setParametrosExibe(filtrosTexto);

        const response = await api.post<IRetornoRelatorio>(
          `/pacientes/buscaavancada`,
          buscaBody,
        );

        const { data, count } = response.data;

        const dadosFormatados = data.map(rel => {
          return {
            ...rel,
            idade: rel.Idade ? rel.Idade : ' ',
            PacDataCadastroFormatado: formataDataExibirRealtorio(
              rel.PacDataCadastro,
            ),
            PacDataNascFormatado: formataDataExibirRealtorio(rel.PacDataNasc),
            linkWhatsappWeb: montaLinkWhatsappWeb(rel.PacCelular),
          };
        });
        setPaginacao(dadosBusca);
        setDadosRelatorio(dadosFormatados);
        setTotalRegistros(count);
      } catch (error) {
        console.log(error);
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      addToast,
      realizouProcedimentos,
      procedimentosRealizados,
      naoRealizouProcedimentos,
      procedimentosNaoRealizados,
      atendidoPelosPerfil,
      perfilAtendimentos,
    ],
  );

  const getRequiredWhenCondition = (message: string): WhenCondition => ({
    is: (value: any) => value !== null && value !== undefined && value !== '',
    then: (schema: Yup.AnySchema) => schema.required(message),
  });

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          dataCadastroInicio: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida'),
          dataCadastroFim: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida')
            .when(
              'dataCadastroInicio',
              getRequiredWhenCondition(
                'Data de fim é obrigatória quando a data de início foi informada',
              ),
            ),
          dataNascimentoInicio: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida'),
          dataNascimentoFim: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida')
            .when(
              'dataNascimentoInicio',
              getRequiredWhenCondition(
                'Data de fim é obrigatória quando a data de início foi informada',
              ),
            ),
          sexo: Yup.string().nullable(true),
          ehAssociado: Yup.string()
            .nullable()
            .transform((valorOriginal, valorBruto) => {
              if (
                valorBruto === null ||
                valorBruto === undefined ||
                valorBruto === ''
              ) {
                return null;
              }
              // // Se já for boolean, retorna como está
              // if (typeof valorBruto === 'boolean') return valorBruto;

              // // Se for string 'true' ou 'false', converte
              // if (typeof valorBruto === 'string') {
              //   if (valorBruto.toLowerCase() === 'true') return true;
              //   if (valorBruto.toLowerCase() === 'false') return false;
              // }

              // Caso não seja conversível, retorna valor original
              return valorOriginal;
            }),
          pessoaFisica: Yup.boolean()
            .nullable()
            .transform((valorOriginal, valorBruto) => {
              if (
                valorBruto === null ||
                valorBruto === undefined ||
                valorBruto === ''
              ) {
                return null;
              }
              // Se já for boolean, retorna como está
              if (typeof valorBruto === 'boolean') return valorBruto;

              // Se for string 'true' ou 'false', converte
              if (typeof valorBruto === 'string') {
                if (valorBruto.toLowerCase() === 'true') return true;
                if (valorBruto.toLowerCase() === 'false') return false;
              }

              // Caso não seja conversível, retorna valor original
              return valorOriginal;
            }),
          dataRealizouInicio: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida'),
          dataRealizouFim: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida')
            .when(
              'dataRealizouInicio',
              getRequiredWhenCondition(
                'Data de fim é obrigatória quando a data de início foi informada',
              ),
            ),
          dataNaoRealizouInicio: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida'),
          dataNaoRealizouFim: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida')
            .when(
              'dataNaoRealizouInicio',
              getRequiredWhenCondition(
                'Data de fim é obrigatória quando a data de início foi informada',
              ),
            ),
          dataAtendimentoPerfilInicio: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida'),
          dataAtendimentoPerfilFim: Yup.date()
            .nullable()
            .transform((value, originalValue) => {
              return originalValue === '' ? null : value;
            })
            .typeError('Data inválida')
            .when(
              'dataAtendimentoPerfilInicio',
              getRequiredWhenCondition(
                'Data de fim é obrigatória quando a data de início foi informada',
              ),
            ),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        handleBuscar({
          ...dados,
          pagina: 1,
          limite: 50,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, handleBuscar],
  );

  const handleProximaPagina = useCallback(
    (page: number) => {
      if (paginacao) handleBuscar({ ...paginacao, pagina: page });
    },
    [handleBuscar, paginacao],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleSelectProcedimentoRealizouChange = useCallback(
    ({ value, label }) => {
      if (value) {
        setProcedimentosRealizados(prev => {
          const jaExiste = prev.some(item => item.ProCodigo === value);
          if (jaExiste) return prev;
          return [...prev, { ProCodigo: value, ProNome: label }]; // adiciona ao array
        });
      }
    },
    [],
  );

  const handleRemoveProcedimentoRealizou = useCallback((ProCodigo: Number) => {
    setProcedimentosRealizados(state => {
      if (state) return state.filter(pro => pro.ProCodigo !== ProCodigo);
      return [];
    });
  }, []);

  const handleSelectProcedimentoNaoRealizouChange = useCallback(
    ({ value, label }) => {
      if (value) {
        setProcedimentosNaoRealizados(prev => {
          const jaExiste = prev.some(item => item.ProCodigo === value);
          if (jaExiste) return prev;
          return [...prev, { ProCodigo: value, ProNome: label }]; // adiciona ao array
        });
      }
    },
    [],
  );

  const handleRemoveProcedimentoNaoRealizou = useCallback(
    (ProCodigo: Number) => {
      setProcedimentosNaoRealizados(state => {
        if (state) return state.filter(pro => pro.ProCodigo !== ProCodigo);
        return [];
      });
    },
    [],
  );

  const handleSelectPerfisChange = useCallback(({ value, label }) => {
    if (value) {
      setPerfilAtendimentos(prev => {
        const jaExiste = prev.some(item => item.ProCodigo === value);
        if (jaExiste) return prev;
        return [...prev, { ProCodigo: value, ProNome: label }]; // adiciona ao array
      });
    }
  }, []);

  const handleRemovePerfis = useCallback((ProCodigo: Number) => {
    setPerfilAtendimentos(state => {
      if (state) return state.filter(pro => pro.ProCodigo !== ProCodigo);
      return [];
    });
  }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">Busca Avançada de Pacientes</h2>
          </div>

          <Form
            ref={formRefBusca}
            initialData={initialData}
            onSubmit={handleSubmitBusca}
          >
            <Row noGutters>
              <Col md={2} className="pr-1">
                <Input
                  name="dataNascimentoInicio"
                  label="Nascimento de"
                  type="date"
                />
              </Col>
              <Col md={2} className="pr-1">
                <Input name="dataNascimentoFim" label="Até" type="date" />
              </Col>
              <Col md={2} className="pr-1">
                <Input
                  name="dataCadastroInicio"
                  label="Cadastro de"
                  type="date"
                />
              </Col>
              <Col md={2} className="pr-1">
                <Input name="dataCadastroFim" label="Até" type="date" />
              </Col>
              <Col md={12} className="pb-1" />
              <Col md={2} className="pr-1">
                <SelectSync
                  name="sexo"
                  label="Sexo"
                  options={optionsSexo}
                  isClearable
                  handleSelectChange={handleOnChangeVazio}
                />
              </Col>
              <Col md={2} className="pr-1">
                <SelectSync
                  name="ehAssociado"
                  label="Associado"
                  options={optionsAssociado}
                  isClearable
                  handleSelectChange={handleOnChangeVazio}
                />
              </Col>
              <Col md={2} className="pr-1">
                <SelectSync
                  name="pessoaFisica"
                  label="Pessoa Fisica"
                  options={optionsSimNao}
                  isClearable
                  handleSelectChange={handleOnChangeVazio}
                />
              </Col>
              <div className="w-100" />
              {/* PROCEDIMENTOS QUE REALIZOU */}
              <Col md={6}>
                <Row className="mt-2">
                  <Col md={4}>
                    <InputCheck
                      name="realizouProcedimento"
                      label="Realizou os Procedimentos"
                      isDisabled={false}
                      onClick={() => {
                        setRealizouProcedimentos(!realizouProcedimentos);
                      }}
                      classSpam={{
                        display: 'block',
                        paddingRight: '10px',
                        marginBottom: '9px',
                        fontWeight: 'bold',
                      }}
                    />
                  </Col>
                </Row>

                <Row
                  className={
                    realizouProcedimentos
                      ? 'mt-2 border rounded p-1 mx-1'
                      : 'd-none'
                  }
                >
                  <Col md={6}>
                    <Input
                      name="dataRealizouInicio"
                      label="Período de (Opcional)"
                      type="date"
                    />
                  </Col>
                  <Col md={6}>
                    <Input name="dataRealizouFim" label="Até" type="date" />
                  </Col>
                  <Col md={12} className="pt-1">
                    <SelectAsync
                      name="realizouProcedimentoBusca"
                      label="Procedimentos"
                      urlApi="procedimentos/combo?termoBusca="
                      placeholder="Digite para buscar"
                      handleSelectChange={
                        handleSelectProcedimentoRealizouChange
                      }
                    />
                    {procedimentosRealizados &&
                      procedimentosRealizados.length >= 0 && (
                        <ul className="mt-2 px-2">
                          {procedimentosRealizados.map(prod => (
                            <li
                              className="d-flex justify-content-between align-items-center"
                              key={`prodreal-${prod.ProCodigo}`}
                            >
                              {prod.ProNome}
                              <Button
                                type="button"
                                variant="outline-danger"
                                size="sm"
                                className="py-0"
                                onClick={() => {
                                  handleRemoveProcedimentoRealizou(
                                    prod.ProCodigo,
                                  );
                                }}
                              >
                                <FaTrashAlt />
                              </Button>
                            </li>
                          ))}
                        </ul>
                      )}
                  </Col>
                </Row>
              </Col>

              {/* PROCEDIMENTOS QUE NÃO REALIZOU */}
              <Col md={6}>
                <Row className="mt-2">
                  <Col md={4}>
                    <InputCheck
                      name="naoRealizouProcedimento"
                      label="Não Realizou os Procedimentos"
                      isDisabled={false}
                      onClick={() => {
                        setNaoRealizouProcedimentos(!naoRealizouProcedimentos);
                      }}
                      classSpam={{
                        display: 'block',
                        paddingRight: '10px',
                        marginBottom: '9px',
                        fontWeight: 'bold',
                      }}
                    />
                  </Col>
                </Row>

                <Row
                  className={
                    naoRealizouProcedimentos
                      ? 'mt-2 border rounded p-1 mx-1'
                      : 'd-none'
                  }
                >
                  <Col md={6}>
                    <Input
                      name="dataNaoRealizouInicio"
                      label="Período de (Opcional)"
                      type="date"
                    />
                  </Col>
                  <Col md={6}>
                    <Input name="dataNaoRealizouFim" label="Até" type="date" />
                  </Col>
                  <Col md={12} className="pt-1">
                    <SelectAsync
                      name="naoRealizouProcedimentoBusca"
                      label="Procedimentos"
                      urlApi="procedimentos/combo?termoBusca="
                      placeholder="Digite para buscar"
                      handleSelectChange={
                        handleSelectProcedimentoNaoRealizouChange
                      }
                    />
                    {procedimentosNaoRealizados &&
                      procedimentosNaoRealizados.length >= 0 && (
                        <ul className="mt-2 px-2">
                          {procedimentosNaoRealizados.map(prod => (
                            <li
                              className="d-flex justify-content-between align-items-center"
                              key={`prodnaoreal-${prod.ProCodigo}`}
                            >
                              {prod.ProNome}
                              <Button
                                type="button"
                                variant="outline-danger"
                                size="sm"
                                className="py-0"
                                onClick={() => {
                                  handleRemoveProcedimentoNaoRealizou(
                                    prod.ProCodigo,
                                  );
                                }}
                              >
                                <FaTrashAlt />
                              </Button>
                            </li>
                          ))}
                        </ul>
                      )}
                  </Col>
                </Row>
              </Col>

              {/* ATENDITO PELOS PERFIS */}
              <Col md={12}>
                <Row className="mt-2">
                  <Col md={4}>
                    <InputCheck
                      name="atendidoPeloPerfil"
                      label="Atendido pelos Perfis"
                      isDisabled={false}
                      onClick={() => {
                        setAtendidoPelosPerfil(!atendidoPelosPerfil);
                      }}
                      classSpam={{
                        display: 'block',
                        paddingRight: '10px',
                        marginBottom: '9px',
                        fontWeight: 'bold',
                      }}
                    />
                  </Col>
                </Row>

                <Row
                  className={
                    atendidoPelosPerfil
                      ? 'mt-2 border rounded p-1 mx-1'
                      : 'd-none'
                  }
                >
                  <Col md={3}>
                    <Input
                      name="dataAtendimentoPerfilInicio"
                      label="Período de (Opcional)"
                      type="date"
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      name="dataAtendimentoPerfilFim"
                      label="Até"
                      type="date"
                    />
                  </Col>
                  <Col md={12} className="pt-1">
                    <SelectAsync
                      name="atendidoPeloPerfilBusca"
                      label="Perfis"
                      urlApi="perfis/combo?PerNome="
                      placeholder="Digite para buscar"
                      handleSelectChange={handleSelectPerfisChange}
                    />
                    {perfilAtendimentos && perfilAtendimentos.length >= 0 && (
                      <ul className="mt-2 px-2">
                        {perfilAtendimentos.map(prod => (
                          <li
                            className="d-flex justify-content-between align-items-center"
                            key={`prodAtendimento-${prod.ProCodigo}`}
                          >
                            {prod.ProNome}
                            <Button
                              type="button"
                              variant="outline-danger"
                              size="sm"
                              className="py-0"
                              onClick={() => {
                                handleRemovePerfis(prod.ProCodigo);
                              }}
                            >
                              <FaTrashAlt />
                            </Button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </Col>
                </Row>
              </Col>

              <Col md={1}>
                <br />
                <Button type="submit" size="sm" variant="outline-secondary">
                  BUSCAR
                </Button>
              </Col>
            </Row>
          </Form>
        </div>

        <div className="bg-white border p-2 my-3">
          <img src={logo} alt="Agenda Facil" /> Impresso em{' '}
          {parametrosExibe.split('-')[0]}
        </div>

        <RelatorioHeader>
          Pacientes {`- ${clinica} -`} {parametrosExibe}
        </RelatorioHeader>
        <div className="bg-white border p-2" style={{ minHeight: '300px' }}>
          {dadosRelatorio && (
            <>
              <b>Total de {totalRegistros} registros</b>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '100%' }}>Nome</th>
                    <th style={{ width: '85px' }}>Nascimento</th>
                    <th style={{ width: '85px' }}>Idade</th>
                    <th style={{ width: '85px' }}>Cadastro</th>
                    <th style={{ width: '85px' }}>Sexo</th>
                    <th style={{ minWidth: '120px' }}>Telefone</th>
                    <th style={{ width: '85px' }}>Telefone 2</th>
                    <th style={{ width: '85px' }}>Email</th>
                    <th style={{ width: '160px' }}>Responsavel</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosRelatorio &&
                    dadosRelatorio.map(rel => (
                      <tr
                        key={`paciente-${rel.PacCodigo}`}
                        data-id={rel.PacCodigo}
                        style={{ fontSize: '.7rem', height: '30px' }}
                      >
                        <td>{rel.PacNome}</td>
                        <td>{rel.PacDataNascFormatado}</td>
                        <td>{rel.Idade}</td>
                        <td>{rel.PacDataCadastroFormatado}</td>
                        <td>{rel.PacSexo}</td>
                        <td>
                          <a
                            href={rel.linkWhatsappWeb}
                            target="_blank"
                            rel="noreferrer"
                            className="p-2"
                          >
                            <FaWhatsapp size={18} color="#25D366" />
                          </a>{' '}
                          {rel.PacCelular}
                        </td>
                        <td>{rel.PacTelefone}</td>
                        <td>{rel.PacEmail}</td>
                        <td>{rel.PacResponsavel}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
          <Paginacao
            limitePagina={paginacao?.limite || 50}
            paginasVizinhas={2}
            totalRegistros={totalRegistros}
            paginaInicio={paginacao?.pagina}
            handleProximaPagina={handleProximaPagina}
          />
        </div>
      </>
    </Container>
  );
};

export default PacienteBuscaAvancada;
